/*
  Textauswahl im Dokument auf eine Textstelle abbilden.

  VEREINFACHUNG DES PROTOTYPS: Eine Markierung wird als Absatz-Kennung plus
  Zeichenbereich innerhalb dieses Absatzes gespeichert — nicht als Koordinate
  auf einer PDF-Seite. Das ist hier zuverlässig, weil die Vorlagentexte
  unveränderlich im Projekt liegen. Bei echten PDFs aus einem
  Ratsinformationssystem ist das erheblich aufwendiger. Siehe VEREINFACHUNGEN.md.
*/

const ABSATZ_MERKMAL = "[data-absatz-id]";

function absatzElementVon(knoten) {
  const element = knoten.nodeType === Node.TEXT_NODE ? knoten.parentElement : knoten;
  return element ? element.closest(ABSATZ_MERKMAL) : null;
}

/* Wie viele Zeichen liegen zwischen dem Anfang von `wurzel` und dem Punkt? */
function zeichenBis(wurzel, behaelter, versatz) {
  const bereich = document.createRange();
  bereich.setStart(wurzel, 0);
  bereich.setEnd(behaelter, versatz);
  return bereich.toString().length;
}

/*
  Liest die aktuelle Auswahl des Nutzers aus.

  Rückgabe:
    null                                  — nichts ausgewählt
    { fehler: "mehrere-absaetze" }        — Auswahl reicht über einen Absatz hinaus
    { fehler: "zu-kurz" }                 — weniger als drei Zeichen
    { absatzId, start, ende, zitat }      — brauchbare Textstelle
*/
export function leseAuswahl(absaetzeNachId) {
  const auswahl = window.getSelection();
  if (!auswahl || auswahl.isCollapsed || auswahl.rangeCount === 0) return null;

  const bereich = auswahl.getRangeAt(0);
  const anfangsAbsatz = absatzElementVon(bereich.startContainer);
  const endAbsatz = absatzElementVon(bereich.endContainer);

  if (!anfangsAbsatz) return null;
  if (anfangsAbsatz !== endAbsatz) return { fehler: "mehrere-absaetze" };

  const absatzId = anfangsAbsatz.dataset.absatzId;
  const absatz = absaetzeNachId[absatzId];
  if (!absatz) return null;

  let start = zeichenBis(anfangsAbsatz, bereich.startContainer, bereich.startOffset);
  let ende = zeichenBis(anfangsAbsatz, bereich.endContainer, bereich.endOffset);
  if (ende < start) [start, ende] = [ende, start];

  /* Leerzeichen an den Rändern gehören nicht zum Zitat. */
  while (start < ende && /\s/.test(absatz.text[start])) start += 1;
  while (ende > start && /\s/.test(absatz.text[ende - 1])) ende -= 1;

  if (ende - start < 3) return { fehler: "zu-kurz" };

  return {
    absatzId,
    start,
    ende,
    zitat: absatz.text.slice(start, ende),
    /*
      Wo die Auswahl auf dem Bildschirm liegt. Ein Pop-up, das dort aufgeht,
      wo eben noch der Finger war, muss nicht gesucht werden — anders als eine
      Leiste am unteren Rand, die man erst wiederfinden muss.
    */
    stelle: rechteckVon(bereich),
  };
}

/*
  Das umschließende Rechteck der Auswahl in Bildschirmkoordinaten.

  Über mehrere Zeilen hinweg liefert getBoundingClientRect ein Rechteck, das
  beide Zeilenenden einschließt und dadurch viel zu breit ist. Für die
  Verankerung zählt der Anfang der Auswahl, deshalb wird das erste Teilstück
  bevorzugt.
*/
function rechteckVon(bereich) {
  const teile = bereich.getClientRects();
  const r = teile.length ? teile[0] : bereich.getBoundingClientRect();
  if (!r || (!r.width && !r.height)) return null;
  return { oben: r.top, unten: r.bottom, links: r.left, rechts: r.right, breite: r.width };
}

export function auswahlAufheben() {
  const auswahl = window.getSelection();
  if (auswahl) auswahl.removeAllRanges();
}

/* Zur Textstelle einer Markierung springen und sie kurz aufblitzen lassen. */
export function springeZuAnnotation(annotationId) {
  const ziel = document.querySelector(`[data-annotation-ids~="${annotationId}"]`);
  if (!ziel) return false;
  /* Bewusst ohne weiches Scrollen: über mehrere Seiten hinweg ist der Sprung
     verständlicher als eine lange Fahrt, und er funktioniert überall gleich. */
  ziel.scrollIntoView({ block: "center" });
  ziel.classList.add("markierung--blitz");
  window.setTimeout(() => ziel.classList.remove("markierung--blitz"), 1600);
  return true;
}
